import Comparison from '@/types/comparison';
import { formatLocalizedString, FormattedHTMLMessage } from '@/utils/i18n';
import React, { FC, ReactElement } from 'react';

interface Props {
  showTop?: boolean;
  isAllMissingOrUnallocatedPortfolios?: boolean;
  comparison: Comparison;
  unallocatedPortfolios: Comparison['modifiedItems'];
}
const UnallocatedPortfoliosBody: FC<Props> = ({ showTop = true, isAllMissingOrUnallocatedPortfolios, comparison, unallocatedPortfolios }): ReactElement => {
  const bodyTextKey = isAllMissingOrUnallocatedPortfolios ? 'AllUnallocatedPortfolios' : 'SomeUnallocatedPortfolios';

  if (!unallocatedPortfolios || unallocatedPortfolios.length === 0) {
    return <></>;
  }

  return (
    <>
      {showTop && (
        <p>
          <FormattedHTMLMessage
            id={`ComparisonMissingItemsModal.Body.${bodyTextKey}.Top`}
            values={{
              count: unallocatedPortfolios.length,
              comparison: comparison.name,
            }}
          />
        </p>
      )}
      {!isAllMissingOrUnallocatedPortfolios && (
        <ul className="items-list">
          {unallocatedPortfolios.map(portfolioItem => (
            <li key={portfolioItem.item._id}>{formatLocalizedString(portfolioItem.item.name)}</li>
          ))}
        </ul>
      )}
    </>
  );
};

export default UnallocatedPortfoliosBody;
